// extracted by mini-css-extract-plugin
export default {"ref_suppressed":"table_ref_suppressed__S1SCs","ref_not_resolved":"table_ref_not_resolved__S3Xqm","ref_not_valid":"table_ref_not_valid__LMhSC","ref_valid":"table_ref_valid__1utZy"};